import { getApiUrl } from '../utils/reactConfig';

interface UploadUrlResponse {
  uploadUrl: string;
  blobName: string;
}

interface DownloadUrlResponse {
  url: string;
}

export class AzureBlobService {
  private apiUrl = getApiUrl();

  private authHeaders(): HeadersInit {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  private async getUploadUrl(fileName: string): Promise<UploadUrlResponse> {
    const res = await fetch(
      `${this.apiUrl}/tasks/v1/library/attachment-upload-url?fileName=${encodeURIComponent(fileName)}`,
      { headers: this.authHeaders() }
    );
    if (!res.ok) throw new Error(`Failed to get upload URL: ${res.status}`);
    return res.json();
  }

  async getDownloadUrl(blobName: string): Promise<string> {
    const res = await fetch(
      `${this.apiUrl}/tasks/v1/library/attachment-download-url?blobName=${encodeURIComponent(blobName)}`,
      { headers: this.authHeaders() }
    );
    if (!res.ok) throw new Error(`Failed to get download URL: ${res.status}`);
    const data: DownloadUrlResponse = await res.json();
    return data.url;
  }

  // Returns the blobName stored in the DB.
  async upload(file: File): Promise<string> {
    const { uploadUrl, blobName } = await this.getUploadUrl(file.name);

    const res = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': file.type
      }
    });

    if (!res.ok) throw new Error(`Azure upload failed: ${res.status} ${res.statusText}`);

    return blobName;
  }
}
